// extracted by mini-css-extract-plugin
export default {"select":"cancel-modal_select__Wi-nY"};